import React, { Component } from 'react';
import { ContentSwitcher, Switch, Button } from 'carbon-components-react';
import Breadcrumb from '../../../shared/breadcrumb/Breadcrumb';
import List from './List/List';

class CategoryModels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }

  changeSelectedTab = ({ index }) => {
    this.setState({ selectedTab: index });
  };

  render() {
    const { selectedTab } = this.state;
    const { history } = this.props;

    return (
      <div>
        <Breadcrumb
          crumb="Cadastro de Modelos / Categorias"
          description="Crie ou gerencie modelos."
        />
        <section className="content-wrapper">
          <ContentSwitcher selectedIndex={selectedTab} onChange={this.changeSelectedTab}>
            <Switch name="message" text="Mensagens" />
            <Switch name="sac" text="SAC" />
          </ContentSwitcher>

          {selectedTab === 0 && <List {...this.props} type="1" />}
          {selectedTab === 1 && <List {...this.props} type="2" />}

          <div className="v-md-margin">
            <div className="bx--col-xs-12 bx--col-sm-12 v-sm-margin">
              <Button
                className="bx--btn--full-width"
                onClick={() => history.push('/admin/modelos-categorias/criar')}
              >
                Criar Categoria
              </Button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default CategoryModels;



// WEBPACK FOOTER //
// ./src/screens/admin/CategoryModels/CategoryModels.js